// src/games/HuntWords/Clue/index.tsx
import React from 'react';

import type { ISolution } from '../huntWordInterface';
import { Container, Row, TextClue } from './styles';

interface ClueProps {
  texto: string[];
  /** Palavras ainda não encontradas. */
  solutions: ISolution[];
  /** Posições (em `texto`) das palavras já encontradas. */
  foundWordIds: number[];
}

const foundStyle: React.CSSProperties = {
  color: '#fff',
  backgroundColor: '#7e4f96',
  paddingLeft: '4px',
  paddingRight: '4px',
  textTransform: 'uppercase',
};
const pendingStyle: React.CSSProperties = { backgroundColor: 'transparent', fontWeight: 'bold', textTransform: 'uppercase' };
const textStyle: React.CSSProperties = { backgroundColor: 'transparent' };

const Clue: React.FC<ClueProps> = ({ texto, solutions, foundWordIds }) => {
  const isPending = (piece: string) => solutions.some((s) => s.solution.toLowerCase() === piece.toLowerCase());

  return (
    <Container>
      <Row>
        {texto.map((piece, index) => {
          const style = foundWordIds.includes(index) ? foundStyle : isPending(piece) ? pendingStyle : textStyle;
          return (
            <TextClue key={index} style={style}>
              {piece}
            </TextClue>
          );
        })}
      </Row>
    </Container>
  );
};

export default Clue;
